/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState } from 'react'

import { ChevronArrowLeftIcon } from '../../assets/icons/ChevronArrowLeftIcon'
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import useCarouselBehaviour from '../../hooks/useCarouselBehaviour/useCarouselBehaviour'
import './CarouselTouchFrendly.scss'

const rootClassName = 'component-carousel-touch-frendly'
interface CarouselTouchFrendlyProps {
  className?: string
  slides?: React.ReactNode[]
}

function CarouselTouchFrendly(props: CarouselTouchFrendlyProps) {
  const [id] = useState<any>(getUniqueKey())
  const [atual, setAtual] = useState<number>(0)
  const [CarouselBehaviour, handleChange] = useCarouselBehaviour({
    atual,
    setAtual,
    slides: props.slides!?.map((slide, index) => {
      return (
        <div key={index} className={`${rootClassName}-slide`}>
          {slide}
        </div>
      )
    })
  })

  return (
    <div
      id={id}
      className={getMergedClassNames([rootClassName, props.className])}
    >
      <div className={`${rootClassName}-outside-content`}>
        {props.slides!.length > 1 && (
          <div
            className={`${rootClassName}-control prev`}
            onClick={() => {
              handleChange(
                atual > 0 ? atual - 1 : props.slides!.length - 1,
                false
              )
            }}
          >
            <div className={`${rootClassName}-icon`}>
              <ChevronArrowLeftIcon />
            </div>
            <div className={`${rootClassName}-shadow`} />
          </div>
        )}
        {props.slides!.length > 1 && (
          <div
            className={`${rootClassName}-control next`}
            onClick={() => {
              handleChange(
                atual < props.slides!.length - 1 ? atual + 1 : 0,
                false
              )
            }}
          >
            <div className={`${rootClassName}-icon`}>
              <ChevronArrowRightIcon />
            </div>
            <div className={`${rootClassName}-shadow`} />
          </div>
        )}
        {CarouselBehaviour}
      </div>
      <div className={`${rootClassName}-balls`}>
        {props.slides?.map((_slide, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                handleChange(index, false)
              }}
              className={getMergedClassNames([
                `${rootClassName}-ball`,
                index === atual ? 'atual' : ''
              ])}
            />
          )
        })}
      </div>
    </div>
  )
}

export default memo(CarouselTouchFrendly)
